import 'css-chunksrc/client/pages/projectPage/exportsPage/timesheetByTaskReport/viewSelect/styles.scss';export default {
  "dataTypeFilter": "_dataTypeFilter_xyb6w_1",
  "input": "_input_xyb6w_7",
  "toggleArrow": "_toggleArrow_xyb6w_23",
  "selectedDataTypes": "_selectedDataTypes_xyb6w_31",
  "placeholder": "_placeholder_xyb6w_40",
  "list": "_list_xyb6w_45",
  "item": "_item_xyb6w_57",
  "typeName": "_typeName_xyb6w_70",
  "opened": "_opened_xyb6w_77"
};